import { type Action } from 'react-sweet-state';

import { defaultStateContextPerKey } from './defaultStateContextPerKey';
import type { ExternalContextTypeAttachment } from './ExternalContextTypeAttachment';
import type { FileTypeAttachment } from './FileTypeAttachment';
import type { State } from './State';

export const updateAttachements: (
	key: string,
	entries: [string, FileTypeAttachment | ExternalContextTypeAttachment][],
	overwrite?: boolean,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Action<State, any, any> = (
	key: string,
	entries: [string, FileTypeAttachment | ExternalContextTypeAttachment][],
	overwrite: boolean = false,
) => {
	return ({ setState, getState }) => {
		const state = getState()[key] || defaultStateContextPerKey;
		setState({
			[key]: {
				attachments: new Map([...(!overwrite ? state.attachments.entries() : []), ...entries]),
			},
		});
	};
};
